import React, { useState } from "react";
import "./LoginSignup.css";
import joi from "joi";
import { Link } from "react-router-dom";

const LoginSignup = () => {
  const loginSchema = joi.object({
    email: joi
      .string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.email": "Invalid email address",
        "string.empty": "Email is required",
      }),
    password: joi.string().required().messages({
      "string.empty": "Password is required",
    }),
    check: joi.boolean().valid(true).required().messages({
      "any.only": "Please accept the terms and conditions",
    }),
  });
  const [form, setForm] = useState({
    email: "",
    password: "",
    check: false,
  });
  const [error, setError] = useState({});
  const handleSubmit = (e) => {
    e.preventDefault();
    const { error } = loginSchema.validate(form, { abortEarly: false });
    if (error) {
      const newErrors = {};
      error.details.forEach((err) => {
        newErrors[err.path[0]] = err.message;
      });
      setError(newErrors);
      return;
    }
    setError({});
    console.log(form);
  };

  return (
    <div className="loginSignup">
      <div className="layer">
        <h1>Login</h1>
        <form onSubmit={handleSubmit}>
          <div className="emailInput">
            <input
              type="email"
              placeholder="Email address"
              value={form.email}
              onChange={(e) => {
                setForm({ ...form, email: e.target.value });
              }}
              style={error.email ? { borderColor: "red" } : {}}
            />
            {error.email && <p className="error">{error.email}</p>}
          </div>

          <div className="passInput">
            <input
              type="password"
              placeholder="Password"
              value={form.password}
              onChange={(e) => {
                setForm({ ...form, password: e.target.value });
              }}
              style={error.password ? { borderColor: "red" } : {}}
            />
            {error.password && <p className="error">{error.password}</p>}
          </div>

          <button type="submit">Continue</button>
          <p>
            Create an account?
            <Link
              to="/signup"
              style={{ textDecoration: "none", marginLeft: "7px" }}
            >
              <span>Click here</span>{" "}
            </Link>
          </p>

          <div className="terms">
            <label>
              <input
                type="checkbox"
                checked={form.check}
                onChange={(e) => setForm({ ...form, check: e.target.checked })}
              />
              <span>
                By continuing, I agree to the terms of use & privacy policy
              </span>
            </label>

            {error.check && <p className="error">{error.check}</p>}
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginSignup;
